<template>
  <div>
    <a-form layout="horizontal">
      <!-- 核查因子 & 标液浓度 -->
      <a-row :gutter="24">
        <a-col :md="12" :sm="24">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="核查因子">
            <a-select v-model="formData.factorCode" placeholder="请选择核查因子" :disabled="disableSubmit" @change="onFactorChange">
              <a-select-option v-for="f in factorOptions" :key="f.code" :value="f.code">
                {{ f.name }}（{{ f.unit }}）
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <!-- 系统测试 -->
      <a-row :gutter="24">
        <a-col :md="12" :sm="24">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="系统测量时间">
            <a-date-picker style="width: 100%" format="YYYY-MM-DD HH:mm" :show-time="{ format: 'HH:mm' }"
              v-model="formData.systemMeasureTime" :disabled="disableSubmit" />
          </a-form-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="系统测试结果">
            <a-input-number v-model="formData.systemTestResult" :disabled="disableSubmit" style="width: 80%"
              @change="calcRecovery" />
            <span style="margin-left: 5px">{{ formData.factorUnit }}</span>
          </a-form-item>
        </a-col>
      </a-row>

      <!-- 加标参数 -->
      <a-row :gutter="24">
        <a-col :md="12" :sm="24">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="加标测试时间">
            <a-date-picker style="width: 100%" format="YYYY-MM-DD HH:mm" :show-time="{ format: 'HH:mm' }"
              v-model="formData.spikedMeasureTime" :disabled="disableSubmit" />
          </a-form-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="加标后测定值">
            <a-input-number v-model="formData.spikedMeasuredValue" :disabled="disableSubmit" style="width: 80%"
              @change="calcRecovery" />
            <span style="margin-left: 5px">{{ formData.factorUnit }}</span>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col :md="6" :sm="12">
          <a-form-item :labelCol="{ span: 14 }" :wrapperCol="{ span: 10 }" label="样品体积(L)">
            <a-input-number v-model="formData.sampleVolume" :disabled="disableSubmit" style="width: 100%" @change="calcRecovery" />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="12">
          <a-form-item :labelCol="{ span: 14 }" :wrapperCol="{ span: 10 }" label="加标体积(L)">
            <a-input-number v-model="formData.spikedVolume" :disabled="disableSubmit" style="width: 100%" @change="calcRecovery" />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="12">
          <a-form-item :labelCol="{ span: 14 }" :wrapperCol="{ span: 10 }" label="加标浓度">
            <div style="display: flex; align-items: center">
              <a-input-number v-model="formData.spikedConcentration" :disabled="disableSubmit" style="flex: 1" @change="calcRecovery" />
              <span style="margin-left: 5px; white-space: nowrap">{{ formData.factorUnit }}</span>
            </div>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="12">
          <a-form-item :labelCol="{ span: 14 }" :wrapperCol="{ span: 10 }" label="加标后水样体积(L)">
            <a-input-number v-model="formData.spikedSampleVolume" :disabled="disableSubmit" style="width: 100%" />
          </a-form-item>
        </a-col>
      </a-row>

      <!-- 加标回收率 & 合格 -->
      <a-row :gutter="24">
        <a-col :md="12" :sm="24">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="加标回收率">
            <span>{{ formData.spikedRecoveryRate != null ? formData.spikedRecoveryRate + '%' : '--' }}</span>
          </a-form-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否合格">
            <a-select v-model="formData.qualified" :disabled="disableSubmit" placeholder="请选择">
              <a-select-option value="yes">合格</a-select-option>
              <a-select-option value="no">不合格</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <!-- 备注 -->
      <a-row>
        <a-col :md="24">
          <a-form-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" label="备注">
            <a-textarea v-model="formData.remark" :disabled="disableSubmit" placeholder="请输入备注" />
          </a-form-item>
        </a-col>
      </a-row>

      <!-- 附件 -->
      <a-row style="margin-top: 5px">
        <a-col>

          <iws-upload ref="itemUpload" :options="{ btnText: '上传附件' }" :disableSubmit="disableSubmit"
            filesrc="om_qc_st21_item" :srcid="formData.id" />
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import moment from 'moment'
import { getAction } from '@/api/manage'
import IwsUpload from '@comp/upload/IwsUpload.vue'

export default {
  name: 'St21MonthSpikedForm',
  components: { IwsUpload },
  props: {
    disableSubmit: { type: Boolean, default: false },
    siteId: { type: [Number, String], default: null },
    st: { type: String, default: '21' },
    maintenanceType: { type: String, default: '' },
    qcMeasure: { type: String, default: '' },
    pagePath: { type: String, default: '/om/qc/ledger' },
    dataItems: { type: Array, default: () => [] },
  },
  data() {
    return {
      formData: {
        id: null,
        qcMeasure: 'spiked_recovery',
        factorCode: undefined,
        factorName: '',
        factorUnit: '',
        standardConcentration: null,
        systemMeasureTime: null,
        systemTestResult: null,
        spikedMeasureTime: null,
        spikedMeasuredValue: null,
        sampleVolume: null,
        spikedVolume: null,
        spikedConcentration: null,
        spikedSampleVolume: null,
        spikedRecoveryRate: null,
        qualified: undefined,
        remark: '',
      },
      factorOptions: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    }
  },
  watch: {
    dataItems: {
      immediate: true,
      handler(val) {
        if (val && val.length > 0) {
          this.formData = { ...this.formData, ...val[0] }
          if (this.formData.systemMeasureTime) this.formData.systemMeasureTime = moment(this.formData.systemMeasureTime)
          if (this.formData.spikedMeasureTime) this.formData.spikedMeasureTime = moment(this.formData.spikedMeasureTime)
        }
      },
    },
  },
  created() { this.loadFactorWhitelist() },
  methods: {
    loadFactorWhitelist() {
      if (!this.siteId) return
      Promise.all([
        getAction(this.pagePath + '/factorWhitelist', { st: '21', qcMeasure: 'spiked_recovery' }),
        getAction('/site/info/factor/find/' + this.siteId)
      ]).then(([resWhite, resSite]) => {
        if (resWhite.success && resWhite.result) {
          let siteFactors = (resSite.success && resSite.result) ? resSite.result : []
          let options = []
          resWhite.result.forEach((code) => {
            let f = siteFactors.find((sf) => sf.code === code)
            if (f) options.push({ code: code, name: f.title, unit: f.unitName || '' })
          })
          this.factorOptions = options
        }
      })
    },
    onFactorChange(code) {
      let f = this.factorOptions.find((i) => i.code === code)
      if (f) { this.formData.factorCode = f.code; this.formData.factorName = f.name; this.formData.factorUnit = f.unit }
    },
    /** 加标回收率 = (加标后-系统结果)×(样品+加标体积) / (加标浓度×加标体积) */
    calcRecovery() {
      let d = this.formData
      if (d.spikedMeasuredValue != null && d.systemTestResult != null &&
          d.sampleVolume != null && d.spikedVolume != null && d.spikedConcentration != null) {
        let denom = d.spikedConcentration * d.spikedVolume
        if (denom === 0) { d.spikedRecoveryRate = null; return }
        d.spikedRecoveryRate = Math.trunc(((d.spikedMeasuredValue - d.systemTestResult) * (d.sampleVolume + d.spikedVolume) / denom) * 100 * 100) / 100
      } else {
        d.spikedRecoveryRate = null
      }
    },
    collectData() {
      if (!this.formData.factorCode) { this.$message.warning('请选择核查因子'); return null }
      if (this.$refs.itemUpload) {
        let fd = this.$refs.itemUpload.getUploadList ? this.$refs.itemUpload.getUploadList() : {}
        this.formData.sysFileList = fd.sysFileList || []; this.formData.fileDelList = fd.fileDelList || []
      }
      return [{ ...this.formData }]
    },
  },
}
</script>
